import { getSubdomain } from '../../../../../packages/kiti/utils/helpers/url'
import window from '../../../../../utils/helpers/window'

export const onInstallService = (config, keepOrigin, integration) => {
  let state = undefined
  if (integration) state = { ...state, integrationId: integration.id }
  if (keepOrigin)
    state = { ...state, origin: encodeURIComponent(`${window.location.pathname}${window.location.search}`) }

  window.location.replace(
    `https://slack.com/oauth/v2/authorize?client_id=${config.CLIENT_ID}&scope=${config.SCOPE?.join(',')}&redirect_uri=${
      config.REDIRECT_URI
    }/${getSubdomain()}${state ? `&state=${JSON.stringify(state)}` : ''}`
  )
}

export const useOnReinstall = (config, origin) => {
  return integration => onInstallService(config, origin, integration)
}
